import { post, request } from "@insite/client-framework/Services/ApiService";

export interface TradeReferenceModel {
    firmName: string;
    contact: string;
    accountNumber: string;
}

export interface CreditCardFormRequest {
    // Personal Information
    name: string;
    email: string;

    // Billing Information
    bTName: string;
    bTAddress1: string;
    bTAddress2?: string;
    bTCity: string;
    bTState: string;
    bTPostalCode: string;
    bTPhone: string;
    bTFaxNumber?: string;
    typeOfBusiness?: string;
    apContact?: string;
    invoiceEmail: string;
    dunsNumber?: string;
    sicCode?:string;
    isReseller?:boolean;

    // Shipping Information
    sTName: string;
    sTAddress1: string;
    sTAddress2: string;
    sTCity:string;
    sTState: string;
    sTPostalCode: string;
    sTPhone: string;
    sTFaxNumber?: string;

    // Bank Reference
   bankName: string;
    bankAddress1: string;
    bankAddress2?: string;
    bankCity: string;
    bankState: string;
    bankPostalCode: string;
    checkingAccountNumber1?: string;
    checkingAccountNumber2?: string;
    loanAccountNumber1?: string;
    loanAccountNumber2?: string;
    bankContact?: string;
    bankPhoneNumber?: string;
    attachment?: any; // You can refine this type based on `EmailAttachment` definition

    // Trade References
    tradeReferences: TradeReferenceModel[];
    onError?: (error: string) => void;
}


export interface CreditCardFormResponse {
    [key: string]: any;
}

function buildFormData(model: CreditCardFormRequest): FormData {
    const formData = new FormData();

    Object.entries(model).forEach(([key, value]) => {
         if (key === "tradeReferences") {
            // Convert tradeReferences array to JSON string
            formData.append(key, JSON.stringify(value));
        } else {
            formData.append(key, value);
        }
    });
    return formData;
}

const creditCardFormApi = "api/v2/submitCreditApplication";

export function getCreditCardFormInfo(model: CreditCardFormRequest) {
    const formData = buildFormData(model);
    return request<CreditCardFormResponse>(
        creditCardFormApi,
        "POST",
        {},
        formData,
    );
}
